import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import moment from "moment";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "customerName",
    dir: "asc",
  },
];

interface ServiceCallGridProps {
  data?: any | null;
}

const ServiceCallGrid = (props: ServiceCallGridProps) => {
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(false);
  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const pageChange = (event) => {
    setPage(event.page);
  };

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const endDateCell = (cellProps: any) => {
    let color = "#c2ffc8";
    if (new Date(cellProps.dataItem.endDate).getTime() < new Date().getTime()) {
      color = "#ffa6a6";
    }

    return (
      <td style={{ backgroundColor: color }}>
        {moment(cellProps.dataItem.endDate).format("DD.MM.YYYY")}
      </td>
    );
  };
  const startDateCell = (cellProps: any) => {
    return <td>{moment(cellProps.dataItem.startDate).format("DD.MM.YYYY")}</td>;
  };

  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          pageable={isPagable}
          data={orderBy(data, sort)}
          //   skip={page.skip}
          //   take={page.take}
          //   onPageChange={pageChange}

          total={data.length}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Column field="type" title="Type" />
          <Column field="status" title="Status" />

          <Column field="machines" title="Machines" />

          <Column field="startDate" title="Start Date" start={startDateCell} />

          <Column field="endDate" title="End Date" cell={endDateCell} />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default ServiceCallGrid;
